import React, {useState, useContext, useEffect} from 'react';
import {Container, Modal, Button, Form, Card} from 'react-bootstrap';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';
import {editAssignment, fetchFullInfoAssignmentAndBook} from '../../../http/bookAPI';
import { Context } from '../../../index';
import {FaRankingStar} from "react-icons/fa6";
import {FaStar} from "react-icons/fa";

const RatingModal = ({ show, onClose, assignobject, setCurrentStep }) => {
    const [rating, setRating] = useState(0);
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);
    const { user, book } = useContext(Context);
    const navigate = useNavigate();
    const [isCanTurnIn, setIsCanTurnIn] = useState(false);


    const [timeLeft, setTimeLeft] = useState({
        hours: 12,
        minutes: 0,
        seconds: 0,
        tenths: 0,
        text: "12h 00m 00.0s"
    });

    useEffect(() => {
        const assign = book.selectedCurrentUserAssign;
        if (!assign) return;

        const INSTANT_TYPES = [1, 7, 10, 11, 14, 15, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];      // типы, где можно сразу сдавать
        const BLOCK_WINDOW_MS = 12 * 60 * 60 * 1000;


        const formatLeft = (ms) => {
            const safeMs = Math.max(ms, 0);
            const totalSeconds = Math.floor(safeMs / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            const tenths = Math.floor((safeMs % 1000) / 100);
            const pad = (n) => String(n).padStart(2, '0');
            return {
                hours,
                minutes,
                seconds,
                tenths,
                text: `${hours}h ${pad(minutes)}m ${pad(seconds)}.${tenths}s`
            };
        };

        const updateStatus = () => {
            // моментальный допуск по типу
            if (INSTANT_TYPES.includes(assign.assTypeId)) {
                setIsCanTurnIn(true);
                setTimeLeft(formatLeft(0));
                return;
            }

            // если нет времени старта — нечего считать (кнопка закрыта, но таймер не ломаем)
            if (!assign.start_read_date) return;

            const startMs = Number(assign.start_read_date) * 60 * 1000;
            const elapsedMs = Date.now() - startMs;
            const remainingMs = Math.max(BLOCK_WINDOW_MS - elapsedMs, 0);

            setIsCanTurnIn(elapsedMs >= BLOCK_WINDOW_MS);
            setTimeLeft(formatLeft(remainingMs));
        };

        updateStatus();                            // первичный расчёт
        const interval = setInterval(updateStatus, 100);
        return () => clearInterval(interval);

        // зависимости: следим за id задания, его ключевыми полями и видимостью (если нужно пересчитывать при открытии модалки и т.п.)
    }, [
        book.selectedCurrentUserAssign?.id,
        book.selectedCurrentUserAssign?.assTypeId,
        book.selectedCurrentUserAssign?.start_read_date,
        show
    ]);

    const NO_RATING_TYPES = [10, 11, 14, 15, 22, 23, 28, 29, 30, 31];
    const assign = book.selectedCurrentUserAssign;
    const isSetStarsRating = Number(assign?.assTypeId) === 32;
    const showRatingUI = assign ? !NO_RATING_TYPES.includes(assign.assTypeId) : true;
    const padCountdown = (value) => String(value ?? 0).padStart(2, '0');
    const CountdownPart = ({value, label, accent = false}) => (
        <div
            className={`d-flex flex-column align-items-center justify-content-center rounded border ${accent ? 'border-primary bg-primary bg-opacity-10' : 'border-secondary border-opacity-25 bg-light'}`}
            style={{
                minWidth: accent ? 58 : 64,
                padding: '4px 7px',
                lineHeight: 1,
                boxShadow: accent ? '0 0 0 1px rgba(13,110,253,.08)' : 'none'
            }}
        >
            <span
                className={accent ? "fw-bold text-primary" : "fw-bold text-dark"}
                style={{
                    fontVariantNumeric: 'tabular-nums',
                    fontSize: accent ? '1.25rem' : '1.15rem',
                    letterSpacing: 0
                }}
            >
                {value}
            </span>
            <span className="text-muted text-uppercase" style={{fontSize: '0.62rem', lineHeight: 1.1}}>
                {label}
            </span>
        </div>
    );

    const internalClose = () => {
      //  if (assignobject.assTypeId === 1 || assignobject.assTypeId === 7) {setIsCanTurnIn(true)}
        onClose();
    }

    // Массив звезд для визуального отображения рейтинга
    const handleStarClick = (index) => {
        setRating(index + 1);
    };

    const renderStars = () => {
        return (
            <div className="d-flex">
                {[...Array(5)].map((_, index) => (
                    <i
                        key={index}
                        className={`bi ${index < rating ? "bi-star-fill" : "bi-star"}`}
                        style={{
                            color: index < rating ? "gold" : "lightgray",
                            fontSize: "24px",
                            cursor: "pointer",
                            marginRight: "6px"
                        }}
                        onClick={() => handleStarClick(index)}
                    ></i>
                ))}
            </div>
        );
    };

    const handleSave = async () => {
        // Если рейтинг меньше 5, обязательно требуется указать причину
        if (showRatingUI && rating < 5 && reason.trim() === "") {
            toast.error("Please provide a reason for a rating lower than 5", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        try {
            setLoading(true);
            // Отправляем запрос на обновление задания с новым рейтингом и причиной отмены
            await editAssignment({
                id: assignobject.id,
                assignment_status: 'REPORTED',
                publish_rev_date: Math.floor(Date.now() / 1000 / 60),
                reviewer_reading_step: 'STEP4',
                ...(showRatingUI ? { rating } : {}),
                ...(showRatingUI && reason.trim() ? { why_not_5_text: reason.trim() } : {}),
            });
            // Обновляем список заданий (если требуется)
            const data = await fetchFullInfoAssignmentAndBook(assignobject.id);
            book?.setSelectedCurrentUserAssign(data);
            setCurrentStep('STEP4');
            toast.success(showRatingUI ? "Rating saved successfully" : "Assignment turned in", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            onClose();
        } catch (error) {
            console.error("Error saving rating", error);
            toast.error("Error saving", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setRating(0);
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <Modal show={show} onHide={onClose} top>
            <div className="modal-content">
                <div className="modal-header small" style={{height:40}}>
                    <h1 className="modal-title fs-5">Turn In this Assignment:</h1>
                    <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                </div>
                {/* Body */}
                <div className="modal-body small" style={{ lineHeight: "1.4" }}>
                    <Container>
                        {isCanTurnIn === true ? (
                            <>
                                <div className="mb-1">
                                    <h6>
                                        Your Amazon Name: {user.user.amz_name || "No Amazon Name provided"}
                                    </h6>
                                    <p className="text-muted mb-2">
                                        All actions related to this assignment must be completed under the same Amazon
                                        profile name you previously provided. If your Amazon name has changed, please contact us.
                                    </p>
                                </div>

                                <div className="mb-1 mt-1">
                                    <h6>
                                        Country: {user.user.amz_country || "No Amazon Country provided"}
                                    </h6>
                                    <p className="text-muted">
                                        Please make sure your purchase or activity is performed on the Amazon marketplace
                                        of the same country. If it was done on a different marketplace, please reach out to us.
                                    </p>
                                </div>

                                {showRatingUI && (
                                    <div className="mb-1 justify-content-center">
                                        <p className="text-muted mt-0">
                                        {isSetStarsRating
                                            ? "Please provide the number of stars you set in the Kindle reader or mobile Kindle app."
                                            : "Please provide the number of stars you gave this item."}
                                        </p>
                                    </div>
                                )}
                                {showRatingUI && (
                                    <div className="d-flex justify-content-center">
                                        <Card className="border border-secondary mb-3" style={{ maxWidth: '260px', width: '100%' }}>
                                            <Card.Body className="p-3">
                                                <div className="d-flex flex-column align-items-center justify-content-center text-center">
                                                    <h6>Set Your Rating:</h6>
                                                    {renderStars()}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                )}
                                <div className="mb-1 justify-content-center">
                                    {showRatingUI && rating === 5 && (
                                    <Form.Group className="mb-2">
                                        <p className="text-muted mb-2">
  <span className="fw-semibold">
    {assignobject?.book?.book_type === "product"
        ? "leave a private note for the seller:"
        : "leave a private note for the author:"}
  </span>{" "}
                                            {assignobject?.book?.book_type === "product"
                                                ? "If you think the product can be improved, please share your honest and detailed feedback here — about quality, packaging, delivery, or anything else. This comment is private and helps the seller improve the listing."
                                                : "If you think the book still needs improvement, please share your honest and detailed feedback here — about content, formatting, or anything else. This comment is private and helps the author make the book better."}
                                        </p>

                                        <Form.Control
                                            as="textarea"
                                            style={{ fontSize: '0.875rem' }}
                                            className="border border-secondary mb-2"
                                            rows={3}
                                            value={reason}
                                            onChange={(e) => setReason(e.target.value)}
                                            placeholder="Enter your private note..."
                                        />
                                        <p className="text-muted">
                                            {assignobject?.book?.book_type === "product" ? (
                                                <>
                                                    Many buyers choose to give the seller the benefit of the doubt — they might leave 4 or even 3 stars here,
                                                    even if they gave 5 stars on Amazon. This gives the seller a chance to improve the product quality, packaging,
                                                    or delivery experience without hurting their public rating. But how you handle it is entirely up to you.
                                                </>
                                            ) : (
                                                <>
                                                    Many readers choose to give the author the benefit of the doubt — they might leave 4 or even 3 stars here,
                                                    even if they gave 5 stars on Amazon. This gives the author a chance to improve the book without hurting their
                                                    public rating. But how you handle it is entirely up to you.
                                                </>
                                            )}
                                        </p>

                                    </Form.Group>
                                        )}
                                </div>

                                {showRatingUI && (rating > 0 && rating < 5) && (
                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted">
                                    <p className="text-muted mb-2">
  <span className="fw-semibold">
    {assignobject?.book?.book_type === "product"
        ? "leave a private note for the seller:"
        : "leave a private note for the author:"}
  </span>{" "}
                                        {assignobject?.book?.book_type === "product"
                                            ? "If you think the product can be improved, please share your honest and detailed feedback here — about quality, packaging, delivery, or anything else. This comment is private and helps the seller improve the listing."
                                            : "If you think the book still needs improvement, please share your honest and detailed feedback here — about content, formatting, or anything else. This comment is private and helps the author make the book better."}
                                    </p>

                                    <p className="mt-1 mb-1 fw-bold" style={{ lineHeight: "1.4" }}>Please tell us why you did not give 5 stars:</p>
                                </Form.Label>

                                <Form.Control
                                    as="textarea"
                                    style={{ fontSize: '0.875rem' }}
                                    className="border border-secondary"
                                    rows={3}
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                    placeholder="Enter your reason..."
                                />
                                <p className="mt-2 fw-bold text-success">
                                    Thank you for being part of this journey. 💛✨
                                </p>
                            </Form.Group>

                        )}
                </>
                ):(
                            <div className="text-muted fst-italic">
                                <h5 className="fw-bold text-danger">
                                    {isSetStarsRating ? "Please wait before submitting your star rating!" : "Please wait before submitting your review!"}
                                </h5>
                                <p>
                                    Unfortunately, you should not complete this assignment right now.
                                    According to Amazon's algorithms, it looks unnatural if a user buys a book, reads it in 5-10 minutes, and immediately leaves feedback.
                                </p>
                                <p>
                                    Please be patient! To avoid unnecessary risks to your Amazon reviewer account, we strongly recommend waiting at least <strong>12 hours</strong> before submitting your feedback.
                                    This precaution helps keep your reviewer account safe and prevents potential sanctions from Amazon marketplace.
                                </p>
                                <p>
                                    This restriction applies only to assignment types that require direct interaction with Amazon to obtain the book,
                                    such as Kindle Unlimited or Verified Purchase assignments in various types.
                                    It does not apply to assignment types where the author has provided a downloadable file.
                                    These are Universal Assignments for different types of books.
                                </p>

                                <div className="d-flex align-items-center flex-wrap gap-2 mt-3">
                                    <h5 className="fw-bold mb-0 me-1">Time left:</h5>
                                    <div
                                        className="d-flex align-items-center gap-1"
                                        aria-label={`Time left: ${timeLeft.text}`}
                                        title={timeLeft.text}
                                    >
                                        <CountdownPart value={timeLeft.hours} label="hours" />
                                        <span className="fw-bold text-primary">:</span>
                                        <CountdownPart value={padCountdown(timeLeft.minutes)} label="min" />
                                        <span className="fw-bold text-primary">:</span>
                                        <CountdownPart value={padCountdown(timeLeft.seconds)} label="sec" />
                                        <span className="fw-bold text-primary">.</span>
                                        <CountdownPart value={timeLeft.tenths} label="1/10" accent />
                                    </div>
                                </div>

                            </div>

                        )}
                    </Container>
                </div>
                {/* Footer */}
                <div
                    className="modal-footer small d-flex align-items-center justify-content-end gap-2 px-2"
                    style={{ height: 50, paddingTop: 0, paddingBottom: 0 }}
                >

                    <Button variant="secondary" onClick={internalClose}
                            className=" text-white btn btn-sm"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleSave}
                        className="text-white btn btn-sm"
                        disabled={loading || !isCanTurnIn}
                    >
                        {loading ? "Saving..." : (
                            <>
                                {showRatingUI ? "Submit Rating" : "Turn In Assignment"}
                            </>
                        )}
                    </Button>

                </div>
            </div>
        </Modal>
    );
};

export default RatingModal;
